<template>
  <div>
    <Breadcrumbs
      title="Delivery Schedule"
      :breadcrumbs="[
        { label: 'Delivery Schedule', path: '' },
        { label: 'Dispatch Schedule', path: '/delivery-schedule' },
      ]"
    />

    <div class="container-fluid">
      <div class="row project-cards">
        <DispatchScheduleData />
      </div>
    </div>
  </div>
</template>

<script>
import DispatchScheduleData from "@/pages/stock/delivery_schedule/delivery_schedule_data.vue";

export default {
  name: "DeliverySchedule",

  components: {
    DispatchScheduleData,
  },
};
</script>